import React from "react";
import { VstButton } from "vstui";
import { Isvg } from "../../components";
import { Button } from "@vitalsource/vstui";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    // Refs
    this.flashcardHeaderRef = React.createRef();
    this.panelTitleRef = React.createRef();

    this.play = this.play.bind(this);
  }

  componentDidMount() {}

  play() {
    Fraction.Router.setRoute(
      "/flashcards/deck/" + this.props.currentDeck.uuid + "?singleDeck=true"
    );
  }

  render() {
    const {
      add,
      close,
      currentDeck,
      playDisabled,
      selectCurrentDeck,
      title
    } = this.props;
    return (
      <div ref={this.flashcardHeaderRef} className="header noselect">
        {currentDeck && (
          <VstButton
            id="header-button"
            className="noButton header-back-button"
            onClick={() => selectCurrentDeck(null)}
            options="btn-24"
          >
            <Isvg src="/img/chevron_left_large.svg" />
            <span className="offScreen">
              {i18n.t("reader.flashcards.back-deck-view")}
            </span>
          </VstButton>
        )}
        <h2
          id="panel-header-flashcards"
          className={`panel-title no-highlight ${
            currentDeck ? "smallHeader" : ""
          }`}
          tabIndex={-1}
          ref={this.panelTitleRef}
        >
          {title}
        </h2>
        {currentDeck && (
          <VstButton
            options="btn-24"
            className={"play-flashcard noButton"}
            onClick={this.play}
            id="flash-card-play"
            disabled={playDisabled}
            title={i18n.t("reader.flashcards.play-card")}
          >
            <span className="offScreen">
              {i18n.t("reader.flashcards.play-card")}
            </span>
          </VstButton>
        )}
        <VstButton
          options="btn-24"
          className={"add-flashcard noButton"}
          onClick={add}
          id="flash-card-add"
          title={i18n.t("reader.flashcards.add-card")}
        >
          <span className="offScreen">
            {i18n.t("reader.flashcards.add-card")}
          </span>
        </VstButton>
        <Button
          className="panel-close-button"
          onClick={close}
          naked
        >
          <span>
            {i18n.t("reader.panels.close-panel", {
              panelName: i18n.t("reader.panels.flashcards")
            })}
          </span>
        </Button>
      </div>
    );
  }
}
